import { render } from "./BrAccount.vue?vue&type=template&id=2e9bec0c&scoped=true"
import script from "./BrAccount.vue?vue&type=script&lang=js"
export * from "./BrAccount.vue?vue&type=script&lang=js"

import "./BrAccount.vue?vue&type=style&index=0&id=2e9bec0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9bec0c"]])

export default __exports__